export const PAYMENT_PURPOSE = {
    INVOICE: {label: "Facture", value: "INVOICE"},
    DEPOSIT: {label: "Acompte", value: "DEPOSIT"},
    CREDIT_NOTE: {label: "Avoir", value: "CREDIT_NOTE"}
}
